import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "./components/landing/Nav";
import Hero from "./components/landing/Hero";
import WhatIs from "./components/landing/WhatIs";
import WhoFor from "./components/landing/WhoFor";
import Problem from "./components/landing/Problem";
import Solution from "./components/landing/Solution";
import Waitlist from "./components/landing/Waitlist";
import Vision from "./components/landing/Vision";
import Footer from "./components/landing/Footer";
import AmbientDust from "./components/landing/AmbientDust";
import CursorTrail from "./components/landing/CursorTrail";
import { ThemeProvider, useTheme } from "./hooks/useTheme";
import DemoPage from "./components/demo/DemoPage";

function LandingPage() {
    const { theme } = useTheme();

    return (
        <div className="App relative">
            <div className="ambient-right" />
            <div className="ambient-left" />
            <div className="grain" />
            <AmbientDust />
            <CursorTrail />

            <Nav />

            <main className="relative z-10">
                <Hero />
                <WhatIs />
                <WhoFor />
                <Problem />
                <Solution />
                <Waitlist />
                <Vision />
            </main>

            <Footer />

            <Toaster
                theme={theme}
                position="bottom-right"
                toastOptions={{
                    style:
                        theme === "dark"
                            ? {
                                  background: "rgba(10,12,22,0.9)",
                                  border: "1px solid rgba(157,76,221,0.35)",
                                  color: "white",
                                  backdropFilter: "blur(12px)",
                              }
                            : {
                                  background: "rgba(255,255,255,0.95)",
                                  border: "1px solid rgba(139,92,246,0.2)",
                                  color: "#111827",
                                  backdropFilter: "blur(12px)",
                                  boxShadow: "0 4px 24px rgba(139,92,246,0.12)",
                              },
                }}
            />
        </div>
    );
}

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/demo" element={<DemoPage />} />
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
